import { useEffect, useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { apiRequest } from '../helpers'

export default function TwoFASetup() {
  const [qr, setQr] = useState('')
  const [manualKey, setManualKey] = useState('')
  const [code, setCode] = useState('')

  useEffect(() => {
    apiRequest(`${process.env.REACT_APP_API_URL}/twofa/begin`, 'GET')
      .then(r => r)
      .then(d => {
        setQr(d.qrDataUrl)
        setManualKey(d.manualKey)
      })
  }, [])

  async function confirm() {
    const r = await apiRequest(`${process.env.REACT_APP_API_URL}/twofa/confirm`, 'POST', {
      token: code,
    })

    alert('2FA uključena!\nSačuvaj recovery kodove:\n' + (r.recoveryCodes || []).join('\n'))
  }

  return (
    <div className='container col-12 col-md-5 col-lg-4 px-4 mx-auto bg-white text-center'>
      <h3 className='mt-3'>Enable 2FA</h3>
      {qr && <img src={qr} alt='Scan QR' className='img-fluid my-3' />}
      <div className='text-start'>
        <small>Manual key:</small> <code>{manualKey}</code>
      </div>
      <Form.Group className='mt-3'>
        <Form.Control
          placeholder='6-cifreni kod'
          value={code}
          onChange={e => setCode(e.target.value)}
        />
      </Form.Group>
      <Button className='mt-3' onClick={confirm}>
        Potvrdi
      </Button>
    </div>
  )
}
